import React from 'react';
import { leftRightPadding } from './styles';

const SubText = ({
  errorHidden = false,
  error,
  hint,
}: {
  errorHidden: boolean | undefined;
  error?: React.ReactNode;
  hint?: React.ReactNode;
}) => (
  <div className={`mt-1 py-0 px-[${leftRightPadding}px] text-[10px] min-h-[11px]`}>
    {error && !errorHidden && <div className="qa-form-error text-venn-alert">{error}</div>}
    {(!error || errorHidden) && hint && <div className="text-venn-grey-10">{hint}</div>}
  </div>
);

export default SubText;
